<template>
  <div>
    <md-table class="historical-channel-sessions">
      <md-table-row>
        <md-table-cell>Channel ID</md-table-cell>
        <md-table-cell>Start Time</md-table-cell>
        <md-table-cell>Stop Time</md-table-cell>
        <md-table-cell>Client Count</md-table-cell>
        <md-table-cell>Duration</md-table-cell>
        <md-table-cell>Quality</md-table-cell>
      </md-table-row>
    </md-table>
    <!-- empty case -->
    <md-table
      class="table-striped table-hover historical-channel-sessions"
      v-if="!channelSessions || !channelSessions.length"
    >
      <md-table-row slot="md-table-row">
        <md-table-cell :colspan="6">{{ emptyMessage }}</md-table-cell>
      </md-table-row>
    </md-table>
    <!-- non-empty case -->
    <md-table
      class="table-striped table-hover historical-channel-sessions data"
      v-for="(channel, index) in channelSessions"
      :key="index"
    >
      <md-table-row
        slot="md-table-row"
        v-on:click="
          getChildren('clientStats', 'client_sessions_historical', channel)
        "
        :key="sessionKey"
      >
        <md-table-cell
          :data-tour="
            index == 0
              ? 'connection_stats_channel_id_historic'
              : false
          "
          >{{ channel.channelId }}</md-table-cell
        >
        <md-table-cell>{{ channel.startTimestamp }}</md-table-cell>
        <md-table-cell>{{ channel.stopTimestamp }}</md-table-cell>
        <md-table-cell>{{ channel.numberOfClients }}</md-table-cell>
        <md-table-cell>{{
          channel.duration ? formatTime(channel.duration) : ""
        }}</md-table-cell>
        <md-table-cell>{{
          channel.quality ? Math.round(channel.quality) + "%" : "-"
        }}</md-table-cell>
      </md-table-row>
      <md-table-row v-if="channel.showChildren">
        <md-table-cell :colspan="6">
          <md-table class="historical-client-sessions">
            <md-table-row>
              <md-table-cell>Client ID</md-table-cell>
              <md-table-cell>Start Time</md-table-cell>
              <md-table-cell>Stop Time</md-table-cell>
              <md-table-cell>Connection Count</md-table-cell>
              <md-table-cell>Duration</md-table-cell>
              <md-table-cell>Quality</md-table-cell>
            </md-table-row>
          </md-table>
          <md-table
            v-for="( client, index ) in channel.children"
            :key="client.clientId"
            class="table-striped table-hover historical-client-sessions data"
          >
            <md-table-row
              slot="md-table-row"
              @click="
                getChildren(
                  'connectionStats',
                  'connection_times_historical',
                  client,
                  channel.channelId
                )
              "
            >
              <md-table-cell
                :data-tour="
                  index == 0
                    ? 'connection_stats_client_id_historic'
                    : false
                "
                >{{ client.clientId }}</md-table-cell
              >
              <md-table-cell>{{ client.startTimestamp }}</md-table-cell>
              <md-table-cell>{{ client.stopTimestamp }}</md-table-cell>
              <md-table-cell>{{ client.numberOfConnections }}</md-table-cell>
              <md-table-cell>{{
                client.duration ? formatTime(client.duration) : ""
              }}</md-table-cell>
              <md-table-cell>{{
                client.quality ? Math.round(client.quality) + "%" : "-"
              }}</md-table-cell>
            </md-table-row>
            <md-table-row v-if="client.showChildren">
              <md-table-cell :colspan="6">
                <md-table class="historical-connection-stats">
                  <md-table-row>
                    <md-table-cell>Connection ID</md-table-cell>
                    <md-table-cell>Start Time</md-table-cell>
                    <md-table-cell>Stop Time</md-table-cell>
                    <md-table-cell>Duration</md-table-cell>
                    <md-table-cell>Max Frame Width</md-table-cell>
                    <md-table-cell>Max Frame Height</md-table-cell>
                    <md-table-cell>Max Pixel Count</md-table-cell>
                    <md-table-cell>Message Count</md-table-cell>
                    <md-table-cell>Quality</md-table-cell>
                  </md-table-row>
                </md-table>
                <md-table
                  class="table-striped table-hover historical-connection-stats data"
                  v-for="( connection, index ) in client.children"
                  :key="connection.id"
                >
                  <md-table-row
                    slot="md-table-row"
                    @click="routeToConnection(connection.id)"
                  >
                    <md-table-cell
                      :data-tour="
                        index == 0
                          ? 'connection_stats_connection_id_historic'
                          : false
                      "
                      >{{ connection.id }}</md-table-cell
                    >
                    <md-table-cell>{{
                      connection.startTimestamp
                    }}</md-table-cell>
                    <md-table-cell>{{
                      connection.stopTimestamp
                    }}</md-table-cell>
                    <md-table-cell>{{ connection.duration }}</md-table-cell>
                    <md-table-cell>{{
                      connection.maxFrameWidth
                    }}</md-table-cell>
                    <md-table-cell>{{
                      connection.maxFrameHeight
                    }}</md-table-cell>
                    <md-table-cell>{{
                      connection.maxPixelCount
                    }}</md-table-cell>
                    <md-table-cell>{{ connection.messageCount }}</md-table-cell>
                    <md-table-cell>{{
                      connection.quality ? Math.round(connection.quality) + "%" : "-"
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>
<script>
import { get } from "vuex-pathify";
export default {
  data: () => ({
    appId: "-",
    sessionKey: 0,
    start: null,
    end: null,
    loading: true
  }),
  props: {
    numberOfDays: null
  },
  computed: {
    channelSessions: get("channelStats/entities"),
    emptyMessage: function() {
      if (this.loading) {
        return "Loading...";
      } else {
        return "There is no historic data available for this application right now.";
      }
    }
  },
  methods: {
    loadChannelStats: function(applicationId) {
      var me = this;
      this.loading = true;
      this.appId = applicationId;
      this.end = this.$store.getters.sqlTimestampGenerator(0);
      this.start = this.$store.getters.sqlTimestampGenerator(this.numberOfDays);
      this.$store
        .dispatch("channelStats/loadEntities", [
          { k: "tag", v: "channel_sessions_historical" },
          { k: "applicationId", v: me.appId },
          { k: "start", v: me.start },
          { k: "end", v: me.end }
        ])
        .then(() => {
          me.loading = false;
          for (var i = 0; i < me.channelSessions.length; i++) {
            me.channelSessions[i].showChildren = false;
            me.channelSessions[i].children = [];
          }
        })
        .catch(() => {
          /* TODO: Should we do something here? */
        });
    },
    getChildren: function(endpoint, tag, item, channelId) {
      var me = this;
      if (item.children.length === 0) {
        var extra = [
          { k: "tag", v: tag },
          { k: "applicationId", v: me.appId },
          { k: "start", v: item.startTimestamp },
          { k: "end", v: item.stopTimestamp }
        ];

        if (endpoint === "clientStats") {
          //add extra info that needs to be sent to the endpoint
          extra.push({ k: "channelId", v: item.channelId });
        } else {
          extra.push({ k: "channelId", v: channelId });
          extra.push({ k: "clientId", v: item.clientId });
        }
        this.$store
          .dispatch(endpoint + "/loadEntities", extra)
          .then(() => {
            item.children = me.$store.get(endpoint + "/entities");

            for (var i = item.children.length - 1; i >= 0; i--) {
              item.children[i].showChildren = false;
              item.children[i].children = [];
            }
            item.showChildren = item.children.length > 0;
            me.bumpKey();
          })
          .catch(() => {
            /* TODO: Should we do something here? */
          });
      } else {
        item.showChildren = !item.showChildren;
        me.bumpKey();
      }
    },
    bumpKey: function() {
      this.sessionKey++;
    },
    routeToConnection: function(id) {
      this.$router.push({
        path: `/connectionstats/${id}`,
        query: { applicationId: this.appId }
      });
    },
    formatTime: function(time){
      var secs = time % 60;
      time = (time - secs) / 60;
      var mins = time % 60;
      var hrs = (time - mins) / 60;
      return hrs + ':' + mins + ':' + secs ;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ table {
  table-layout: fixed;
  width: 100%;
}
div.historical-channel-sessions table td {
  width: 16.5%;
}
div.historical-client-sessions table td {
  width: 16.5%;
}
div.historical-connection-stats table td {
  width: 11%;
}
.md-table.data .md-table-row {
  cursor: pointer;
}
/deep/ .md-table-cell:last-child .md-table-cell-container {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
